/** Selector de elementos enfocables para el focus-trap. */
export const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'textarea:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',')

/** Etiqueta accesible por defecto del botón de cierre. */
export const CLOSE_LABEL = 'Cerrar'

/** Tamaño del icono de cierre (px), alineado con IconButton size `m`. */
export const CLOSE_ICON_SIZE = 20

/**
 * Duración máxima de la animación de salida (ms), igual que `--motion-slow`
 * (la de `panel-out`). Pausa de seguridad para desmontar el panel si
 * `animationend` no llega (p. ej. pestaña en segundo plano).
 */
export const EXIT_FALLBACK_MS = 320
